import { useLatestValue } from "@/src/lib/actions";

export const usePageSize = () => useLatestValue<number>("op:page-size") ?? 10;
export const useSearch = () => useLatestValue<string>("op:search") ?? "";
